// extracted by mini-css-extract-plugin
export default {"wrapper":"MapLinksControls_wrapper__3HS4C","open":"MapLinksControls_open__7jOVJ"};